import {
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import React from 'react';

export const TransferPersonalDataTable = () => {
  return (
    <Stack textAlign={'left'} py={8} align={'start'} w='full'>
      <TableContainer whiteSpace={'wrap' as any}>
        <Table fontSize={{ base: 12, md: 14 }}>
          <Thead>
            <Tr>
              <Th>Party Name and Jurisdiction</Th>
              <Th>Purpose</Th>
              <Th>Data Disclosed</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>Cloud providers</Td>
              <Td>For storage purposes</Td>
              <Td>
                User name, correspondence, corporate documentation, dates of
                birth, identifying documentation, transactional activity and
                analysis, financial information
              </Td>
            </Tr>
            <Tr>
              <Td>Legal counsel</Td>
              <Td>
                As part of attorney-client relationships, legal counseling and
                litigations
              </Td>
              <Td>Any relevant information, as the case may be</Td>
            </Tr>
            <Tr>
              <Td>Sumsub.com (https://sumsub.com/privacy-notice/)</Td>
              <Td>
                {`As part of the verification process, your name will undergo
              scrutiny against WorldCheck's database of politically exposed
              persons, as well as individuals and organizations associated with
              heightened risk profiles, for Anti-Money Laundering (AML) and
              counter-terrorism financing purposes. This comprehensive check is
              designed to aid in the identification and management of financial,
              regulatory, and reputational risks.`}
              </Td>
              <Td>Your Name, date of birth, ID </Td>
            </Tr>
            <Tr>
              <Td>Maybe in the future, provider will be updated</Td>
              <Td>
                … employs public blockchain addresses for the purpose of
                conducting investigations, compliance assessments, and risk
                management checks
              </Td>
              <Td>Public blockchain addresses</Td>
            </Tr>
            <Tr>
              <Td>Google Authenticator </Td>
              <Td>
                When utilizing the Site services, you may receive 2FA SMS or
                service emails. These notifications are triggered, for example,
                when you log in, withdraw funds, receive a deposit, open a new
                account or sub-account, or confirm pop-ups.
              </Td>
              <Td>
                Your email address, your IP address and your mobile number
              </Td>
            </Tr>
            <Tr>
              <Td>
                Any third party that we believe is necessary to address and
                resolve the Security Breach, if one occurs
              </Td>
              <Td>
                In case of an actual or suspected Security Breach, we may need
                help by a third party that we believe is necessary to address
                and resolve the Security Breach.
              </Td>
              <Td>
                Any of the Personal Information, taking into account necessity
                and data minimization and/or all information and documents you
                agreed to provide
              </Td>
            </Tr>
            <Tr>
              <Td>Financial Institutions</Td>
              <Td>When processing and facilitating withdrawals or deposits</Td>
              <Td>
                User name, corporate documentation, transactional activity,
                financial information
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Stack>
  );
};
